import Const from '../Const'
import {observable,action} from 'mobx'
class InputState {
  @observable inputValue = ""
  @observable inputIsFocus = false
  @observable inputIsComposition = false
  @observable clickedUrl
  @action changeInputValue = (value) => {
    this.inputValue = value
  }
  @action changeClickedUrl = (url)=>{
    if(url !== null && url !== "" )
      this.clickedUrl = url
  }
  @action switchInputFocus = (flag)=>{
    this.inputIsFocus = flag
  }
  @action switchInputComposition = (flag)=>{
    this.inputIsComposition = flag
  }
}
export const inputState = new InputState()



// WEBPACK FOOTER //
// ./src/stateClass/InputState.js